var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " @import url(https://fonts.googleapis.com/css2?family=Ubuntu:wght@400&amp;display=swap); "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(510,512) rotate(0,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(45,95,138)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "79.1784px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -245.78321838378906,
    y: -31.671360000000007,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Vida saud\xE1vel")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,428) rotate(12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(65,202,230)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "79.1784px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -176.23239135742188,
    y: -31.671360000000007,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Vida ativa")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(510,622) rotate(-12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(95,191,114)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "79.1784px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -414.05902099609375,
    y: -31.671360000000007,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Longevidade produtiva")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(510,648) rotate(-12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(88,150,191)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -228.53482055664062,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Relacionamento saud\xE1vel")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(392,560) rotate(-12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(45,95,138)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -195.3865966796875,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Alimenta\xE7\xE3o saud\xE1vel")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(512,682) rotate(-12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(177,232,115)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -160.9915771484375,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Qualidade de vida")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(510,718) rotate(-12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(88,150,191)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -163.4059600830078,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Sa\xFAde no trabalho")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(512,328) rotate(0,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(45,95,138)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -155.72744750976562,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Cora\xE7\xE3o saud\xE1vel")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(354,432) rotate(0,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(88,150,191)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -157.3502197265625,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Sa\xFAde do c\xE9rebro")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(226,506) rotate(12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(177,232,115)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -143.75450134277344,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Sa\xFAde espiritual")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(514,752) rotate(-12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(45,95,138)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -152.2642059326172,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Sa\xFAde emocional")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,342) rotate(-12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(88,150,191)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -141.37969970703125,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Mente saud\xE1vel")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(756,414) rotate(12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(88,150,191)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -140.6672821044922,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Sa\xFAde muscular")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(634,758) rotate(-12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(177,232,115)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -126.83406066894531,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Boca saud\xE1vel")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(236,394) rotate(-12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(45,95,138)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -125.8643569946289,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Peso saud\xE1vel")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(794,622) rotate(-12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(95,191,114)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -128.14019775390625,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Sono saud\xE1vel")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,566) rotate(-12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(65,202,230)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -105.5202407836914,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Sa\xFAde f\xEDsica")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(844,570) rotate(-12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(88,150,191)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -109.95319366455078,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Sa\xFAde social")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(838,468) rotate(12,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(177,232,115)",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: "39.5892px",
    fontStyle: "normal",
    fontWeight: "normal",
    x: -91.44956970214844,
    y: -15.835680000000004,
    textAnchor: "start",
    dominantBaseline: "alphabetic",
    fillOpacity: 1
  }, "Bem Estar")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login-logo.40de259d3e0e64e78c573f74f161a826.svg";
export { ForwardRef as ReactComponent };